import React from "react";
import { Dialog, DialogContent, DialogTitle, GridLegacy } from "@mui/material";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import FormTextTC from "../../components/Forms/FormTextTC";
import FormV2 from "../JamezzForm/FormV2";
import AuthProvider from "../../auth/AuthProvider";

const endPoint = "core/profiles/duplicate";

function DuplicateProfileDialog(props) {
  return (
    <Dialog fullWidth={true} maxWidth={"lg"} onClose={() => props.onClose()} open={true}>
      <DialogTitle>
        <TranslationWrapper tDefault={"Duplicate profile"} tKey={"profiles.duplicateProfile"} />
      </DialogTitle>
      <DialogContent>
        <AuthProvider prefix={"create_new_profile"}>
          <FormV2
            endPoint={endPoint}
            getEditLink={(row) => {
              return `./${row.id}/edit`;
            }}
            mode={"onSubmit"}
            onSubmit={(data) => {
              data.set("duplicate_from_id", props.profile.id);
            }}
            revalidateMode={"onChange"}
          >
            <GridLegacy container spacing={1}>
              <FormTextTC name={"name"} permissionKey={"duplicate"} tDefault={"Profile name"} tKey={"profiles.name"} />
            </GridLegacy>
          </FormV2>
        </AuthProvider>
      </DialogContent>
    </Dialog>
  );
}

export default DuplicateProfileDialog;
